import { QUERY_KEYS } from '../../../../consts';
import { getAtomWithMutation } from '../../../../utils';
import { createFinalSignDocsService } from '../../../../services/documents/post/create-final-sign-docs';

export const createFinalSignDocsAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.DOCUMENTS.CREATE_FINAL_SIGN_DOCS,
  mutationFn: () => createFinalSignDocsService,
});
